import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { environment } from 'src/environments/environment';
import { localStorageService } from '../localstorage.service';
import { BehaviorSubject } from 'rxjs';
// import { MainService } from '../main/main.service';

@Injectable({
    providedIn: 'root'
})

export class SocketsService {
    private socket!: Socket;
    socketConnected: BehaviorSubject<any> = new BehaviorSubject(0);
    panel_type: any = 1;
    constructor(private _local: localStorageService) {
        this.socket = io(environment.socketBaseUrl, {
            path: '/api/socket.io',
            transports: ['websocket']
        });
    }

    connect() {
        console.log('socket.connected', this.socket.connected);
        this.socket.connect();
        this.socket.on('connect', () => {
            console.log('Socket connected:', this.socket.id);
            this.socketConnected.next(1);
        });
        this.socket.on('new_notification', (data) => {
            console.log('new_notification:', data);
        });
        this.socket.on('disconnect', () => {
            console.log('Socket disconnect:', this.socket.id);
            this.socket.connect();
        });
        
        this.socket.on('connect_error', (error:any) => {
            console.error('Connection failed:', error.message);
        });

        let userData = this._local.customGetItem('admin_profile');
        if (typeof userData == 'string') {
            userData = JSON.parse(userData);
        }
        if (userData.admin_id) {
            this.emit('ADMIN_CONNECTED', {admin_id: userData.admin_id});
        }
    }

    // Emit events to the server
    emit(eventName: string, data: any): void {
        data["user_type"] = this.panel_type;
        this.socket.emit(eventName, data);
    }

    // Listen for events from the server
    on(eventName: string, data: any) {
        this.socket.on(eventName, data);
    }

    // Set off events from the server
    off(eventName: string, ) {
        this.socket.off(eventName);
    }

    disconnect(): void {
        if (this.socket) {
          this.socket.disconnect();
        }
    }
}